export const actionTypes = [
  {
    id: 0,
    labelKey: 'search/selectors/action_type/archived',
  },
  {
    id: 1,
    labelKey: 'search/selectors/action_type/answered',
  },
  {
    id: 2,
    labelKey: 'search/selectors/action_type/archived_auto',
  },
  {
    id: 16,
    labelKey: 'search/selectors/action_type/comment',
  },
  {
    id: 17,
    labelKey: 'search/selectors/action_type/help_request',
  },
  {
    id: 18,
    labelKey: 'search/selectors/action_type/help_answer',
  },
  {
    id: 19,
    labelKey: 'search/selectors/action_type/acquired',
  },
  {
    id: 20,
    labelKey: 'search/selectors/action_type/released',
  },
  {
    id: 21,
    labelKey: 'search/selectors/action_type/steal',
  },
  {
    id: 27,
    labelKey: 'search/selectors/action_type/assigned_to',
  },
  {
    id: 33,
    labelKey: 'search/selectors/action_type/tag',
  },
  {
    id: 37,
    labelKey: 'search/selectors/action_type/on_hold',
  },
];
